import i18n from "i18next";
import { generatePath } from "react-router";
import _ from "lodash";

const routes = {
    homepage: "/",
    single_hike: "/itineraires/:slug",
    summary: "/summary",
    full: "/full",
    dev_account: "/devaccount",
    book: "/book",
    book_edit: "/book/:reference",
    book_service: "/book/:serviceSlug",
    book_service_next: "/book/:serviceSlug/:next",
    assets: "/assets",
    contact: "/contact",
    cgv: "/cgv",
    account_dashboard: "/account/dashboard",
    account_informations: "/account/informations",
    account_history: "/account/history",
    account_drafts: "/account/drafts",
    security_sign_out: "/security/sign-out",
    customer_reservation: "/account/reservation/:reference",
    customer_reservation_invoice: "/account/reservation/:reference/invoice/:invoiceId",
    optimalles_list: "/optimalles",
    optimalles_list_by_theme: "/optimalles/:theme",
    optimalles_list_by_theme_and_hike: "/optimalles/:theme/:hike",
    login: "/?login",
    others: "/*path",
     //marevan
    account_reservations: "/account/reservations",
    account_quotations: "/account/quotations",
    account_invoices: "/account/invoices",
    account_documents: "/account/documents",

};

export function generate(path, params) {
    let route = routes[path];
    if (route) {
        let path = "/:locale/" + _.trimStart(route, "/");
        return generatePath(path, {
            ...params,
            locale: i18n.language,
        });
    }
    return null;
}
